import AppDropDown from "@toothfairy/shared-ui/AppDropDown";
import AppTextInput from "@toothfairy/shared-ui/AppTextInput";
import AppTheme from "@toothfairy/shared-ui/AppTheme";
import React from "react";
import { View } from "react-native";
import ToothFairyButton from "../../../../../Components/ToothFairyComponents/ToothFairyButton";
import { Department } from "../../../../../models";

const QaPreselectionToolbar = ({
  searchBtnLabel = "Search",
  searchBtnAccLabel = "searchButton",
  handleSearch = () => {},
  labelText,
  setLabelText,
  valueText,
  setValueText,
  agentType,
  setAgentType,
  agentDepartment,
  setAgentDepartment,
}) => {
  const { currentTheme } = AppTheme?.useTheme();
  return (
    <View
      style={{
        flexDirection: "row",
        alignItems: "center",
        flexWrap: "wrap",
        marginTop: -10,
        paddingHorizontal: 10,
      }}
    >
      <View
        style={{
          flexDirection: "row",
          alignItems: "center",
          marginTop: 10,
        }}
      >
        <AppTextInput
          value={labelText}
          onChangeText={setLabelText}
          style={{
            // fontSize: 16,
            marginLeft: 0,
          }}
          placeholder="Name"
        />
      </View>
      <View
        style={{
          flexDirection: "row",
          alignItems: "center",
          marginTop: 10,
        }}
      >
        <AppTextInput
          value={valueText}
          onChangeText={setValueText}
          style={{
            // fontSize: 16,
            marginLeft: 0,
          }}
          width={300}
          placeholder="Description"
        />
      </View>
      <View
        style={{
          flexDirection: "row",
          alignItems: "center",
          marginTop: 10,
        }}
      >
        <AppDropDown
          dropDownStyle={{
            width: 200,
            marginLeft: 5,
            borderColor: currentTheme?.theme?.border_color,
          }}
          isElevated={false}
          dropdownIconColor="transparent"
          items={[
            {
              name: "All agent types",
              id: null,
            },
            {
              name: "Operator",
              id: "retriever",
            },
            {
              name: "Orchestrator",
              id: "planner",
            },
            {
              name: "Assistant",
              id: "chatter",
            },
            {
              name: "Programmer",
              id: "coder",
            },
            {
              name: "Desktop",
              id: "computer",
            },
          ]}
          propertyLabel="name"
          propertyValue="id"
          selectedValue={agentType}
          onValueChange={(itemValue, itemIndex) => {
            setAgentType(itemValue);
          }}
        />
        <AppDropDown
          dropDownStyle={{
            width: 200,
            marginLeft: 5,
            borderColor: currentTheme?.theme?.border_color,
          }}
          isElevated={false}
          dropdownIconColor="transparent"
          items={[
            {
              name: "All departments",
              id: null,
            },
            ...Object.values(Department).map((dept) => ({
              name: dept
                .toLowerCase()
                .replace(/_/g, " ")
                .replace(/\b\w/g, (c) => c.toUpperCase()),
              id: dept,
            })),
          ]}
          propertyLabel="name"
          propertyValue="id"
          selectedValue={agentDepartment}
          onValueChange={(itemValue, itemIndex) => {
            setAgentDepartment(itemValue);
          }}
        />
      </View>

      {/* <ToothFairyButton
        wrapperStyle={{ marginTop: 10 }}
        title={searchBtnLabel}
        accessibilityLabel={searchBtnAccLabel}
        onPress={() => handleSearch(labelText, valueText, agentType)}
      /> */}
    </View>
  );
};

export default QaPreselectionToolbar;
